import React from "react";
import {Parallax} from "react-parallax";
import styles from './ParallaxSection.module.css'
import CtaButtonHover from "../../common/ctaButton";


interface ctaProps {
    message: string;
    subMessage: string;
    buttonText?: string;
}


const ParallaxSection: React.FC<ctaProps> = ({message, subMessage, buttonText}) => {
    return (
        <section>
            <Parallax
                bgImage="/images/home/parallax.jpg"
                strength={300} // Adjust this value for stronger/weaker parallax
                className={styles.section}
            >
                <div  className={styles.outerDivContainer}>
                    <div className={styles.innerDivContainer}>
                        <h2 className={styles.message}>
                            {message}
                        </h2>
                        <p className={styles.subMessage}>
                            {subMessage}
                        </p>
                        <div className={styles.ctaButtonHover}>
                            <CtaButtonHover link={"contact"} buttonTxt={buttonText!}/>
                        </div>
                    </div>
                </div>
            </Parallax>
        </section>

    );
};

export default ParallaxSection;
